
import { RouteDefs } from "@/router/RouteDefs";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class TermsOfUseAndPrivacyPolicy extends Vue {
  public readonly contactUs = RouteDefs.ContactUs.name;
}
